import { Transfer } from '@varo/graphql-schema-types';
import GetTransfer from 'services/graphql/queries/MoveMoney/GetTransfer';
import { CombinedError, useQuery, UseQueryExecute } from 'urql';

interface TransferHistoryData {
  fetching: boolean;
  error?: CombinedError;
  transfer?: Transfer;
  refetchQuery: UseQueryExecute;
}

const useTransferDetails = ({
  transferId,
}: {
  transferId: string;
}): TransferHistoryData => {
  const [{ data, fetching, error }, refetchQuery] = useQuery<{
    transfer: Transfer;
  }>({
    query: GetTransfer,
    requestPolicy: 'cache-and-network',
    variables: {
      id: transferId,
    },
  });

  return {
    fetching,
    error,
    transfer: data?.transfer,
    refetchQuery,
  };
};

export default useTransferDetails;
